import ServicesList from "../../utility/ServicesList";

const Services = () => {
    return (
        <div key="first-column" className="first-column">
            <ServicesList />
        </div>
    );
};

export default Services;
